var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSine = function SvgSine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 12.88c-2.2 0-2.87-2.9-3.52-5.7-.47-2-1.06-4.56-2.08-4.56S2.42 5.17 1.9 7v.13H.32l.08-.28C1.18 4 2 1.12 4.2 1.12S7.09 4 7.74 6.84c.46 2 1 4.54 2.06 4.54S11.52 8.82 12 7v-.12h1.55l-.12.41C12.75 10 12 12.88 9.8 12.88Z"
  })));
};

export default SvgSine;